import { NgModule } from '@angular/core';
import { FocusItemDirective } from './focus-item.directive';

@NgModule({
  imports: [],
  declarations: [FocusItemDirective],
  exports: [FocusItemDirective]
})
export class FocusItemModule {}
